import React, { SVGProps } from 'react';

// Toolbar icons (ported from the dashboard DocxIcons). 24x24, currentColor.
const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='currentColor'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  />
);

// Green "saved" tick — matches the task-view completion check in the assistant
// (stroked polyline, emerald). Not the fill-based toolbar Svg helper.
export const CheckIcon = (p: SVGProps<SVGSVGElement>) => (
  <svg width='14' height='14' viewBox='0 0 24 24' fill='none' {...p}>
    <polyline
      points='20 6 9 17 4 12'
      stroke='#10b981'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

// "✕" — matches the task-view error mark in the assistant (stroked, uses
// currentColor so the caller sets the red).
export const CloseIcon = (p: SVGProps<SVGSVGElement>) => (
  <svg width='14' height='14' viewBox='0 0 24 24' fill='none' {...p}>
    <path
      d='M18 6 6 18'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='m6 6 12 12'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export const UndoIcon = (p: SVGProps<SVGSVGElement>) => (
  <Svg {...p}>
    <path d='M9.707 3.707a1 1 0 0 0-1.414-1.414l-5 5a1 1 0 0 0 0 1.414l5 5a1 1 0 0 0 1.414-1.414L6.414 9H14.5a4.5 4.5 0 0 1 0 9H11a1 1 0 1 0 0 2h3.5a6.499 6.499 0 1 0 0-13H6.414l3.293-3.293Z' />
  </Svg>
);

export const RedoIcon = (p: SVGProps<SVGSVGElement>) => (
  <Svg {...p}>
    <path d='M15.707 2.293a1 1 0 1 0-1.414 1.414L17.586 7H9.5a6.5 6.5 0 1 0 0 13H13a1 1 0 1 0 0-2H9.5a4.5 4.5 0 1 1 0-9h8.086l-3.293 3.293a1 1 0 0 0 1.414 1.414l5-5a1 1 0 0 0 0-1.414l-5-5Z' />
  </Svg>
);

export const MinusIcon = (p: SVGProps<SVGSVGElement>) => (
  <Svg {...p}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4 12C4 11.4477 4.44772 11 5 11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H5C4.44772 13 4 12.5523 4 12Z'
    />
  </Svg>
);

export const PlusIcon = (p: SVGProps<SVGSVGElement>) => (
  <Svg {...p}>
    <path d='M13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5V11H5C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13H11V19C11 19.5523 11.4477 20 12 20C12.5523 20 13 19.5523 13 19V13H19C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11H13V5Z' />
  </Svg>
);

export const FitToPageIcon = (p: SVGProps<SVGSVGElement>) => (
  <Svg {...p}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5 4C4.73478 4 4.48043 4.10536 4.29289 4.29289C4.10536 4.48043 4 4.73478 4 5V7C4 7.55228 3.55228 8 3 8C2.44772 8 2 7.55228 2 7V5C2 4.20435 2.31607 3.44129 2.87868 2.87868C3.44129 2.31607 4.20435 2 5 2H7C7.55228 2 8 2.44772 8 3C8 3.55228 7.55228 4 7 4H5Z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M16 3C16 2.44772 16.4477 2 17 2H19C19.7957 2 20.5587 2.31607 21.1213 2.87868C21.6839 3.44129 22 4.20435 22 5V7C22 7.55228 21.5523 8 21 8C20.4477 8 20 7.55228 20 7V5C20 4.73478 19.8946 4.48043 19.7071 4.29289C19.5196 4.10536 19.2652 4 19 4H17C16.4477 4 16 3.55228 16 3Z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M21 16C21.5523 16 22 16.4477 22 17V19C22 19.7957 21.6839 20.5587 21.1213 21.1213C20.5587 21.6839 19.7957 22 19 22H17C16.4477 22 16 21.5523 16 21C16 20.4477 16.4477 20 17 20H19C19.2652 20 19.5196 19.8946 19.7071 19.7071C19.8946 19.5196 20 19.2652 20 19V17C20 16.4477 20.4477 16 21 16Z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3 16C3.55228 16 4 16.4477 4 17V19C4 19.2652 4.10536 19.5196 4.29289 19.7071C4.48043 19.8946 4.73478 20 5 20H7C7.55228 20 8 20.4477 8 21C8 21.5523 7.55228 22 7 22H5C4.20435 22 3.44129 21.6839 2.87868 21.1213C2.31607 20.5587 2 19.7957 2 19V17C2 16.4477 2.44772 16 3 16Z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6 9C6 7.89543 6.89543 7 8 7H16C17.1046 7 18 7.89543 18 9V15C18 16.1046 17.1046 17 16 17H8C6.89543 17 6 16.1046 6 15V9ZM16 9H8V15H16V9Z'
    />
  </Svg>
);

export const ChevronDownIcon = (p: SVGProps<SVGSVGElement>) => (
  <Svg {...p}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5.29289 8.29289C5.68342 7.90237 6.31658 7.90237 6.70711 8.29289L12 13.5858L17.2929 8.29289C17.6834 7.90237 18.3166 7.90237 18.7071 8.29289C19.0976 8.68342 19.0976 9.31658 18.7071 9.70711L12.7071 15.7071C12.3166 16.0976 11.6834 16.0976 11.2929 15.7071L5.29289 9.70711C4.90237 9.31658 4.90237 8.68342 5.29289 8.29289Z'
    />
  </Svg>
);

export const TextIcon = (p: SVGProps<SVGSVGElement>) => (
  <Svg {...p}>
    <path d='M3 4C3 3.44772 3.44772 3 4 3H20C20.5523 3 21 3.44772 21 4V7C21 7.55228 20.5523 8 20 8C19.4477 8 19 7.55228 19 7V5H13V19H15C15.5523 19 16 19.4477 16 20C16 20.5523 15.5523 21 15 21H9C8.44772 21 8 20.5523 8 20C8 19.4477 8.44772 19 9 19H11V5H5V7C5 7.55228 4.55228 8 4 8C3.44772 8 3 7.55228 3 7V4Z' />
  </Svg>
);

export const HeadingOneIcon = (p: SVGProps<SVGSVGElement>) => (
  <Svg {...p}>
    <path d='M5 6C5 5.44772 4.55228 5 4 5C3.44772 5 3 5.44772 3 6V18C3 18.5523 3.44772 19 4 19C4.55228 19 5 18.5523 5 18V13H11V18C11 18.5523 11.4477 19 12 19C12.5523 19 13 18.5523 13 18V6C13 5.44772 12.5523 5 12 5C11.4477 5 11 5.44772 11 6V11H5V6Z' />
    <path d='M21.0001 10C21.0001 9.63121 20.7971 9.29235 20.472 9.11833C20.1468 8.94431 19.7523 8.96338 19.4454 9.16795L16.4454 11.168C15.9859 11.4743 15.8617 12.0952 16.1681 12.5547C16.4744 13.0142 17.0953 13.1384 17.5548 12.8321L19.0001 11.8685V18C19.0001 18.5523 19.4478 19 20.0001 19C20.5524 19 21.0001 18.5523 21.0001 18V10Z' />
  </Svg>
);

export const HeadingTwoIcon = (p: SVGProps<SVGSVGElement>) => (
  <Svg {...p}>
    <path d='M5 6C5 5.44772 4.55228 5 4 5C3.44772 5 3 5.44772 3 6V18C3 18.5523 3.44772 19 4 19C4.55228 19 5 18.5523 5 18V13H11V18C11 18.5523 11.4477 19 12 19C12.5523 19 13 18.5523 13 18V6C13 5.44772 12.5523 5 12 5C11.4477 5 11 5.44772 11 6V11H5V6Z' />
    <path d='M22.0001 12C22.0001 10.7611 21.1663 9.79297 20.0663 9.42632C18.9547 9.05578 17.6171 9.28724 16.4001 10.2C15.9582 10.5314 15.8687 11.1582 16.2001 11.6C16.5314 12.0418 17.1582 12.1314 17.6001 11.8C18.383 11.2128 19.0455 11.1942 19.4338 11.3237C19.8339 11.457 20.0001 11.7389 20.0001 12C20.0001 12.4839 19.8554 12.7379 19.6537 12.9481C19.4275 13.1837 19.1378 13.363 18.7055 13.6307C18.6313 13.6767 18.553 13.7252 18.4701 13.777C17.9572 14.0975 17.3128 14.5261 16.8163 15.2087C16.3007 15.9177 16.0001 16.8183 16.0001 18C16.0001 18.5523 16.4478 19 17.0001 19H21.0001C21.5523 19 22.0001 18.5523 22.0001 18C22.0001 17.4477 21.5523 17 21.0001 17H18.131C18.21 16.742 18.3176 16.5448 18.4338 16.385C18.6873 16.0364 19.0429 15.7775 19.5301 15.473C19.5898 15.4357 19.6536 15.3966 19.7205 15.3556C20.139 15.0992 20.6783 14.7687 21.0964 14.3332C21.6447 13.7621 22.0001 13.0161 22.0001 12Z' />
  </Svg>
);

export const HeadingThreeIcon = (p: SVGProps<SVGSVGElement>) => (
  <Svg {...p}>
    <path d='M4 5C4.55228 5 5 5.44772 5 6V11H11V6C11 5.44772 11.4477 5 12 5C12.5523 5 13 5.44772 13 6V18C13 18.5523 12.5523 19 12 19C11.4477 19 11 18.5523 11 18V13H5V18C5 18.5523 4.55228 19 4 19C3.44772 19 3 18.5523 3 18V6C3 5.44772 3.44772 5 4 5Z' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M19.4608 11.2169C19.1135 11.0531 18.5876 11.0204 18.0069 11.3619C17.5309 11.642 16.918 11.4831 16.638 11.007C16.358 10.531 16.5169 9.91809 16.9929 9.63807C18.1123 8.97962 19.3364 8.94691 20.314 9.40808C21.2839 9.86558 21.9999 10.818 21.9999 12C21.9999 12.7957 21.6838 13.5587 21.1212 14.1213C20.5586 14.6839 19.7956 15 18.9999 15C18.4476 15 17.9999 14.5523 17.9999 14C17.9999 13.4477 18.4476 13 18.9999 13C19.2651 13 19.5195 12.8947 19.707 12.7071C19.8946 12.5196 19.9999 12.2652 19.9999 12C19.9999 11.6821 19.8159 11.3844 19.4608 11.2169Z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M18.0001 14C18.0001 13.4477 18.4478 13 19.0001 13C19.7957 13 20.5588 13.3161 21.1214 13.8787C21.684 14.4413 22.0001 15.2043 22.0001 16C22.0001 17.2853 21.2767 18.3971 20.1604 18.8994C19.0257 19.41 17.642 19.2315 16.4001 18.3C15.9582 17.9686 15.8687 17.3418 16.2001 16.9C16.5314 16.4582 17.1582 16.3686 17.6001 16.7C18.3581 17.2685 18.9744 17.24 19.3397 17.0756C19.7234 16.9029 20.0001 16.5147 20.0001 16C20.0001 15.7348 19.8947 15.4804 19.7072 15.2929C19.5196 15.1054 19.2653 15 19.0001 15C18.4478 15 18.0001 14.5523 18.0001 14Z'
    />
  </Svg>
);

export const BoldIcon = (p: SVGProps<SVGSVGElement>) => (
  <Svg {...p}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6 2.5C5.17157 2.5 4.5 3.17157 4.5 4V20C4.5 20.8284 5.17157 21.5 6 21.5H15C16.4587 21.5 17.8576 20.9205 18.8891 19.8891C19.9205 18.8576 20.5 17.4587 20.5 16C20.5 14.5413 19.9205 13.1424 18.8891 12.1109C18.6781 11.9 18.4518 11.7079 18.2128 11.5359C19.041 10.5492 19.5 9.29829 19.5 8C19.5 6.54131 18.9205 5.14236 17.8891 4.11091C16.8576 3.07946 15.4587 2.5 14 2.5H6ZM14 10.5C14.663 10.5 15.2989 10.2366 15.7678 9.76777C16.2366 9.29893 16.5 8.66304 16.5 8C16.5 7.33696 16.2366 6.70107 15.7678 6.23223C15.2989 5.76339 14.663 5.5 14 5.5H7.5V10.5H14ZM7.5 18.5V13.5H15C15.663 13.5 16.2989 13.7634 16.7678 14.2322C17.2366 14.7011 17.5 15.337 17.5 16C17.5 16.663 17.2366 17.2989 16.7678 17.7678C16.2989 18.2366 15.663 18.5 15 18.5H7.5Z'
    />
  </Svg>
);

export const ItalicIcon = (p: SVGProps<SVGSVGElement>) => (
  <Svg {...p}>
    <path d='M15.0222 3H19C19.5523 3 20 3.44772 20 4C20 4.55228 19.5523 5 19 5H15.693L10.443 19H14C14.5523 19 15 19.4477 15 20C15 20.5523 14.5523 21 14 21H9.02418C9.00802 21.0004 8.99181 21.0004 8.97557 21H5C4.44772 21 4 20.5523 4 20C4 19.4477 4.44772 19 5 19H8.30704L13.557 5H10C9.44772 5 9 4.55228 9 4C9 3.44772 9.44772 3 10 3H14.9782C14.9928 2.99968 15.0075 2.99967 15.0222 3Z' />
  </Svg>
);

export const StrikeIcon = (p: SVGProps<SVGSVGElement>) => (
  <Svg {...p}>
    <path d='M9.00039 3H16.0001C16.5524 3 17.0001 3.44772 17.0001 4C17.0001 4.55229 16.5524 5 16.0001 5H9.00011C8.68006 4.99983 8.36412 5.07648 8.07983 5.22349C7.79555 5.37051 7.55069 5.5836 7.36585 5.84487C7.181 6.10614 7.06155 6.40796 7.01754 6.72497C6.97352 7.04198 7.00623 7.36492 7.11292 7.66667C7.29701 8.18737 7.02414 8.75872 6.50344 8.94281C5.98274 9.1269 5.4114 8.85403 5.2273 8.33333C5.01393 7.72984 4.94851 7.08396 5.03654 6.44994C5.12456 5.81592 5.36346 5.21229 5.73316 4.68974C6.10285 4.1672 6.59256 3.74101 7.16113 3.44698C7.72955 3.15303 8.36047 2.99975 9.00039 3Z' />
    <path d='M18 13H20C20.5523 13 21 12.5523 21 12C21 11.4477 20.5523 11 20 11H4C3.44772 11 3 11.4477 3 12C3 12.5523 3.44772 13 4 13H14C14.7956 13 15.5587 13.3161 16.1213 13.8787C16.6839 14.4413 17 15.2044 17 16C17 16.7956 16.6839 17.5587 16.1213 18.1213C15.5587 18.6839 14.7956 19 14 19H6C5.44772 19 5 19.4477 5 20C5 20.5523 5.44772 21 6 21H14C15.3261 21 16.5979 20.4732 17.5355 19.5355C18.4732 18.5979 19 17.3261 19 16C19 14.9119 18.6453 13.8604 18 13Z' />
  </Svg>
);

export const FontColorIcon = (p: SVGProps<SVGSVGElement>) => (
  <Svg {...p}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12.8944 5.55279C12.725 5.214 12.3787 5 12 5C11.6212 5 11.2749 5.214 11.1055 5.55279L5.10555 17.5528C4.85856 18.0468 5.05878 18.6474 5.55276 18.8944C6.04674 19.1414 6.64741 18.9412 6.8944 18.4472L8.64957 14.9369C8.75862 14.9777 8.87671 15 9 15H15C15.1233 15 15.2413 14.9777 15.3504 14.9369L17.1055 18.4472C17.3525 18.9412 17.9532 19.1414 18.4472 18.8944C18.9412 18.6474 19.1414 18.0468 18.8944 17.5528L12.8944 5.55279ZM14.3819 13L12 8.23607L9.61801 13H14.3819Z'
    />
  </Svg>
);

export const LinkIcon = (p: SVGProps<SVGSVGElement>) => (
  <Svg {...p}>
    <path d='M16.9958 1.06669C15.4226 1.05302 13.907 1.65779 12.7753 2.75074L12.765 2.76086L11.045 4.47086C10.6534 4.86024 10.6515 5.49341 11.0409 5.88507C11.4303 6.27673 12.0634 6.27858 12.4551 5.88919L14.1697 4.18456C14.9236 3.45893 15.9319 3.05752 16.9784 3.06662C18.0272 3.07573 19.0304 3.49641 19.772 4.23804C20.5137 4.97967 20.9344 5.98292 20.9435 7.03171C20.9526 8.07776 20.5515 9.08563 19.8265 9.83941L16.833 12.8329C16.4274 13.2386 15.9393 13.5524 15.4019 13.7529C14.8645 13.9533 14.2903 14.0359 13.7181 13.9949C13.146 13.9539 12.5894 13.7904 12.0861 13.5154C11.5827 13.2404 11.1444 12.8604 10.8008 12.401C10.47 11.9588 9.84333 11.8685 9.40108 12.1993C8.95883 12.5301 8.86849 13.1568 9.1993 13.599C9.71464 14.288 10.3721 14.858 11.1272 15.2705C11.8822 15.683 12.7171 15.9283 13.5753 15.9898C14.4334 16.0513 15.2948 15.9274 16.1009 15.6267C16.907 15.326 17.639 14.8555 18.2473 14.247L21.2472 11.2471L21.2593 11.2347C22.3523 10.1031 22.9571 8.58751 22.9434 7.01433C22.9297 5.44115 22.2987 3.93628 21.1863 2.82383C20.0738 1.71138 18.5689 1.08036 16.9958 1.06669Z' />
    <path d='M10.4247 8.0102C9.56657 7.94874 8.70522 8.07256 7.89911 8.37326C7.09305 8.67395 6.36096 9.14458 5.75272 9.753L2.75285 12.7529L2.74067 12.7653C1.64772 13.8969 1.04295 15.4125 1.05662 16.9857C1.07029 18.5589 1.70131 20.0637 2.81376 21.1762C3.9262 22.2886 5.43108 22.9196 7.00426 22.9333C8.57744 22.947 10.0931 22.3422 11.2247 21.2493L11.2371 21.2371L12.9471 19.5271C13.3376 19.1366 13.3376 18.5034 12.9471 18.1129C12.5565 17.7223 11.9234 17.7223 11.5328 18.1129L9.82932 19.8164C9.07555 20.5414 8.06768 20.9425 7.02164 20.9334C5.97285 20.9243 4.9696 20.5036 4.22797 19.762C3.48634 19.0203 3.06566 18.0171 3.05655 16.9683C3.04746 15.9222 3.44851 14.9144 4.17355 14.1606L7.16719 11.167C7.5727 10.7613 8.06071 10.4476 8.59811 10.2471C9.13552 10.0467 9.70976 9.96412 10.2819 10.0051C10.854 10.0461 11.4106 10.2096 11.9139 10.4846C12.4173 10.7596 12.8556 11.1397 13.1992 11.599C13.53 12.0412 14.1567 12.1316 14.5989 11.8007C15.0412 11.4699 15.1315 10.8433 14.8007 10.401C14.2854 9.71205 13.6279 9.14198 12.8729 8.72948C12.1178 8.31697 11.2829 8.07166 10.4247 8.0102Z' />
  </Svg>
);

export const InsertImageIcon = (p: SVGProps<SVGSVGElement>) => (
  <Svg {...p}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M20 2C20 1.44772 19.5523 1 19 1C18.4477 1 18 1.44772 18 2V4H16C15.4477 4 15 4.44772 15 5C15 5.55228 15.4477 6 16 6H18V8C18 8.55228 18.4477 9 19 9C19.5523 9 20 8.55228 20 8V6H22C22.5523 6 23 5.55228 23 5C23 4.44772 22.5523 4 22 4H20V2ZM5 4C4.73478 4 4.48043 4.10536 4.29289 4.29289C4.10536 4.48043 4 4.73478 4 5V19C4 19.2652 4.10536 19.5196 4.29289 19.7071C4.48043 19.8946 4.73478 20 5 20H5.58579L14.379 11.2068C14.9416 10.6444 15.7045 10.3284 16.5 10.3284C17.2955 10.3284 18.0584 10.6444 18.621 11.2068L20 12.5858V12C20 11.4477 20.4477 11 21 11C21.5523 11 22 11.4477 22 12V14.998C22 14.9994 22 15.0007 22 15.002V19C22 19.7957 21.6839 20.5587 21.1213 21.1213C20.5587 21.6839 19.7957 22 19 22H6.00219C6.00073 22 5.99927 22 5.99781 22H5C4.20435 22 3.44129 21.6839 2.87868 21.1213C2.31607 20.5587 2 19.7957 2 19V5C2 4.20435 2.31607 3.44129 2.87868 2.87868C3.44129 2.31607 4.20435 2 5 2H12C12.5523 2 13 2.44772 13 3C13 3.55228 12.5523 4 12 4H5ZM8.41422 20H19C19.2652 20 19.5196 19.8946 19.7071 19.7071C19.8946 19.5196 20 19.2652 20 19V15.4142L17.207 12.6212C17.0195 12.4338 16.7651 12.3284 16.5 12.3284C16.2349 12.3284 15.9806 12.4337 15.7931 12.6211L8.41422 20ZM6.87868 6.87868C7.44129 6.31607 8.20435 6 9 6C9.79565 6 10.5587 6.31607 11.1213 6.87868C11.6839 7.44129 12 8.20435 12 9C12 9.79565 11.6839 10.5587 11.1213 11.1213C10.5587 11.6839 9.79565 12 9 12C8.20435 12 7.44129 11.6839 6.87868 11.1213C6.31607 10.5587 6 9.79565 6 9C6 8.20435 6.31607 7.44129 6.87868 6.87868ZM9 8C8.73478 8 8.48043 8.10536 8.29289 8.29289C8.10536 8.48043 8 8.73478 8 9C8 9.26522 8.10536 9.51957 8.29289 9.70711C8.48043 9.89464 8.73478 10 9 10C9.26522 10 9.51957 9.89464 9.70711 9.70711C9.89464 9.51957 10 9.26522 10 9C10 8.73478 9.89464 8.48043 9.70711 8.29289C9.51957 8.10536 9.26522 8 9 8Z'
    />
  </Svg>
);

export const TableIcon = (p: SVGProps<SVGSVGElement>) => (
  <Svg {...p}>
    <g fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round'>
      <rect x='3' y='4' width='18' height='16' rx='1.5' />
      <line x1='3' y1='10' x2='21' y2='10' />
      <line x1='3' y1='15' x2='21' y2='15' />
      <line x1='9' y1='4' x2='9' y2='20' />
      <line x1='15' y1='4' x2='15' y2='20' />
    </g>
  </Svg>
);

// Table-editing icons (TableGroup). Same stroke style as TableIcon. The
// row/column insert icons draw the plus on the ABOVE/LEFT side — rotate 180°
// at the call site for below/right.
export const InsertRowIcon = (p: SVGProps<SVGSVGElement>) => (
  <Svg {...p}>
    <g fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round'>
      <rect x='3' y='13' width='18' height='7' rx='1.5' />
      <line x1='12' y1='13' x2='12' y2='20' />
      <line x1='12' y1='3' x2='12' y2='9' />
      <line x1='9' y1='6' x2='15' y2='6' />
    </g>
  </Svg>
);

export const InsertColumnIcon = (p: SVGProps<SVGSVGElement>) => (
  <Svg {...p}>
    <g fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round'>
      <rect x='13' y='3' width='7' height='18' rx='1.5' />
      <line x1='13' y1='12' x2='20' y2='12' />
      <line x1='3' y1='12' x2='9' y2='12' />
      <line x1='6' y1='9' x2='6' y2='15' />
    </g>
  </Svg>
);

export const DeleteRowIcon = (p: SVGProps<SVGSVGElement>) => (
  <Svg {...p}>
    <g fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round'>
      <rect x='3' y='9' width='12' height='6' rx='1' />
      <line x1='17.5' y1='10' x2='21.5' y2='14' />
      <line x1='21.5' y1='10' x2='17.5' y2='14' />
    </g>
  </Svg>
);

export const DeleteColumnIcon = (p: SVGProps<SVGSVGElement>) => (
  <Svg {...p}>
    <g fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round'>
      <rect x='9' y='3' width='6' height='12' rx='1' />
      <line x1='10' y1='17.5' x2='14' y2='21.5' />
      <line x1='14' y1='17.5' x2='10' y2='21.5' />
    </g>
  </Svg>
);

export const DeleteTableIcon = (p: SVGProps<SVGSVGElement>) => (
  <Svg {...p}>
    <g fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round'>
      <rect x='3' y='4' width='18' height='16' rx='1.5' />
      <line x1='3' y1='9' x2='21' y2='9' />
      <line x1='9.5' y1='12' x2='14.5' y2='17' />
      <line x1='14.5' y1='12' x2='9.5' y2='17' />
    </g>
  </Svg>
);

export const MergeCellsIcon = (p: SVGProps<SVGSVGElement>) => (
  <Svg {...p}>
    <g
      fill='none'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <rect x='3' y='4' width='18' height='16' rx='1.5' />
      <line x1='12' y1='4' x2='12' y2='7' />
      <line x1='12' y1='17' x2='12' y2='20' />
      <path d='M6 12h3.5' />
      <path d='M8 10.5 9.5 12 8 13.5' />
      <path d='M18 12h-3.5' />
      <path d='M16 10.5 14.5 12 16 13.5' />
    </g>
  </Svg>
);

export const BordersIcon = (p: SVGProps<SVGSVGElement>) => (
  <Svg {...p}>
    <g fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round'>
      <rect x='4' y='5' width='16' height='14' rx='1.5' />
      <line x1='12' y1='5' x2='12' y2='19' />
      <line x1='4' y1='12' x2='20' y2='12' />
    </g>
  </Svg>
);

export const ShadingIcon = (p: SVGProps<SVGSVGElement>) => (
  <Svg {...p}>
    <path
      fill='none'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
      d='M12 3.8C9.6 6.7 6.5 10.7 6.5 13.5a5.5 5.5 0 0 0 11 0c0-2.8-3.1-6.8-5.5-9.7Z'
    />
  </Svg>
);

export const BulletListIcon = (p: SVGProps<SVGSVGElement>) => (
  <Svg {...p}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7 6C7 5.44772 7.44772 5 8 5H21C21.5523 5 22 5.44772 22 6C22 6.55228 21.5523 7 21 7H8C7.44772 7 7 6.55228 7 6Z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7 12C7 11.4477 7.44772 11 8 11H21C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13H8C7.44772 13 7 12.5523 7 12Z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7 18C7 17.4477 7.44772 17 8 17H21C21.5523 17 22 17.4477 22 18C22 18.5523 21.5523 19 21 19H8C7.44772 19 7 18.5523 7 18Z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2 6C2 5.44772 2.44772 5 3 5H3.01C3.56228 5 4.01 5.44772 4.01 6C4.01 6.55228 3.56228 7 3.01 7H3C2.44772 7 2 6.55228 2 6Z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2 12C2 11.4477 2.44772 11 3 11H3.01C3.56228 11 4.01 11.4477 4.01 12C4.01 12.5523 3.56228 13 3.01 13H3C2.44772 13 2 12.5523 2 12Z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2 18C2 17.4477 2.44772 17 3 17H3.01C3.56228 17 4.01 17.4477 4.01 18C4.01 18.5523 3.56228 19 3.01 19H3C2.44772 19 2 18.5523 2 18Z'
    />
  </Svg>
);

export const NumberListIcon = (p: SVGProps<SVGSVGElement>) => (
  <Svg {...p}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9 6C9 5.44772 9.44772 5 10 5H21C21.5523 5 22 5.44772 22 6C22 6.55228 21.5523 7 21 7H10C9.44772 7 9 6.55228 9 6Z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9 12C9 11.4477 9.44772 11 10 11H21C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13H10C9.44772 13 9 12.5523 9 12Z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9 18C9 17.4477 9.44772 17 10 17H21C21.5523 17 22 17.4477 22 18C22 18.5523 21.5523 19 21 19H10C9.44772 19 9 18.5523 9 18Z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3 6C3 5.44772 3.44772 5 4 5H5C5.55228 5 6 5.44772 6 6V10C6 10.5523 5.55228 11 5 11C4.44772 11 4 10.5523 4 10V7C3.44772 7 3 6.55228 3 6Z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3 10C3 9.44772 3.44772 9 4 9H6C6.55228 9 7 9.44772 7 10C7 10.5523 6.55228 11 6 11H4C3.44772 11 3 10.5523 3 10Z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5.82219 13.0431C6.54543 13.4047 6.99997 14.1319 6.99997 15C6.99997 15.5763 6.71806 16.0426 6.48747 16.35C6.31395 16.5814 6.1052 16.8044 5.91309 17H5.99997C6.55226 17 6.99997 17.4477 6.99997 18C6.99997 18.5523 6.55226 19 5.99997 19H3.99997C3.44769 19 2.99997 18.5523 2.99997 18C2.99997 17.4237 3.28189 16.9575 3.51247 16.65C3.74323 16.3424 4.03626 16.0494 4.26965 15.8161C4.27745 15.8083 4.2852 15.8006 4.29287 15.7929C4.55594 15.5298 4.75095 15.3321 4.88748 15.15C4.96287 15.0495 4.99021 14.9922 4.99911 14.9714C4.99535 14.9112 4.9803 14.882 4.9739 14.8715C4.96613 14.8588 4.95382 14.845 4.92776 14.8319C4.87723 14.8067 4.71156 14.7623 4.44719 14.8944C3.95321 15.1414 3.35254 14.9412 3.10555 14.4472C2.85856 13.9533 3.05878 13.3526 3.55276 13.1056C4.28839 12.7378 5.12272 12.6934 5.82219 13.0431Z'
    />
  </Svg>
);

export const AlignLeftIcon = (p: SVGProps<SVGSVGElement>) => (
  <Svg {...p}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2 6C2 5.44772 2.44772 5 3 5H21C21.5523 5 22 5.44772 22 6C22 6.55228 21.5523 7 21 7H3C2.44772 7 2 6.55228 2 6Z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2 12C2 11.4477 2.44772 11 3 11H15C15.5523 11 16 11.4477 16 12C16 12.5523 15.5523 13 15 13H3C2.44772 13 2 12.5523 2 12Z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2 18C2 17.4477 2.44772 17 3 17H17C17.5523 17 18 17.4477 18 18C18 18.5523 17.5523 19 17 19H3C2.44772 19 2 18.5523 2 18Z'
    />
  </Svg>
);

export const AlignCenterIcon = (p: SVGProps<SVGSVGElement>) => (
  <Svg {...p}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2 6C2 5.44772 2.44772 5 3 5H21C21.5523 5 22 5.44772 22 6C22 6.55228 21.5523 7 21 7H3C2.44772 7 2 6.55228 2 6Z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6 12C6 11.4477 6.44772 11 7 11H17C17.5523 11 18 11.4477 18 12C18 12.5523 17.5523 13 17 13H7C6.44772 13 6 12.5523 6 12Z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4 18C4 17.4477 4.44772 17 5 17H19C19.5523 17 20 17.4477 20 18C20 18.5523 19.5523 19 19 19H5C4.44772 19 4 18.5523 4 18Z'
    />
  </Svg>
);

export const AlignRightIcon = (p: SVGProps<SVGSVGElement>) => (
  <Svg {...p}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2 6C2 5.44772 2.44772 5 3 5H21C21.5523 5 22 5.44772 22 6C22 6.55228 21.5523 7 21 7H3C2.44772 7 2 6.55228 2 6Z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8 12C8 11.4477 8.44772 11 9 11H21C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13H9C8.44772 13 8 12.5523 8 12Z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6 18C6 17.4477 6.44772 17 7 17H21C21.5523 17 22 17.4477 22 18C22 18.5523 21.5523 19 21 19H7C6.44772 19 6 18.5523 6 18Z'
    />
  </Svg>
);

export const AlignJustifyIcon = (p: SVGProps<SVGSVGElement>) => (
  <Svg {...p}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2 6C2 5.44772 2.44772 5 3 5H21C21.5523 5 22 5.44772 22 6C22 6.55228 21.5523 7 21 7H3C2.44772 7 2 6.55228 2 6Z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2 12C2 11.4477 2.44772 11 3 11H21C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13H3C2.44772 13 2 12.5523 2 12Z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2 18C2 17.4477 2.44772 17 3 17H21C21.5523 17 22 17.4477 22 18C22 18.5523 21.5523 19 21 19H3C2.44772 19 2 18.5523 2 18Z'
    />
  </Svg>
);

// Tray with a down arrow (line style), matching the "Download" button in the mock.
export const DownloadIcon = (p: SVGProps<SVGSVGElement>) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth={2}
    strokeLinecap='round'
    strokeLinejoin='round'
    xmlns='http://www.w3.org/2000/svg'
    {...p}
  >
    <path d='M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4' />
    <polyline points='7 10 12 15 17 10' />
    <line x1='12' y1='15' x2='12' y2='3' />
  </svg>
);

export const SignatureIcon = (p: SVGProps<SVGSVGElement>) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth={2}
    strokeLinecap='round'
    strokeLinejoin='round'
    xmlns='http://www.w3.org/2000/svg'
    {...p}
  >
    <path d='M12 20h9' />
    <path d='M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z' />
  </svg>
);

// Indeterminate spinner in currentColor (SMIL-animated so it needs no injected
// keyframes and is SSR-safe under Next).
export const SpinnerIcon = (p: SVGProps<SVGSVGElement>) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...p}
  >
    <circle
      cx='12'
      cy='12'
      r='9'
      stroke='currentColor'
      strokeOpacity={0.35}
      strokeWidth={3}
    />
    <path
      d='M12 3a9 9 0 0 1 9 9'
      stroke='currentColor'
      strokeWidth={3}
      strokeLinecap='round'
    >
      <animateTransform
        attributeName='transform'
        type='rotate'
        from='0 12 12'
        to='360 12 12'
        dur='0.7s'
        repeatCount='indefinite'
      />
    </path>
  </svg>
);

export const SaveIcon = (p: SVGProps<SVGSVGElement>) => (
  <Svg {...p}>
    <path d='M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z' />
  </Svg>
);

// Stacked blocks — the reorderable "sections" list. Placeholder glyph; freely
// swappable for the reference artifact's icon.
export const SectionsIcon = (p: SVGProps<SVGSVGElement>) => (
  <Svg {...p}>
    <rect x='4' y='4' width='16' height='4' rx='1.5' />
    <rect x='4' y='10' width='16' height='4' rx='1.5' />
    <rect x='4' y='16' width='11' height='4' rx='1.5' />
  </Svg>
);

// Notebook — the reorderable document "sections".
export const NotebookIcon = (p: SVGProps<SVGSVGElement>) => (
  <Svg {...p}>
    <path
      d='M7 4h10a1.5 1.5 0 0 1 1.5 1.5v13A1.5 1.5 0 0 1 17 20H7a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z'
      fill='none'
      stroke='currentColor'
      strokeWidth='1.7'
      strokeLinejoin='round'
    />
    <path d='M8.5 4v16' fill='none' stroke='currentColor' strokeWidth='1.7' />
    <path
      d='M11.5 9h4M11.5 12.5h4'
      fill='none'
      stroke='currentColor'
      strokeWidth='1.7'
      strokeLinecap='round'
    />
  </Svg>
);

// Review/tracked-changes glyph: lines of text with a diff caret.
export const ChangesIcon = (p: SVGProps<SVGSVGElement>) => (
  <Svg {...p}>
    <path d='M4 6a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1Zm0 5a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1Zm0 5a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1Z' />
    <path d='M18 9.5a1 1 0 0 1 1 1V13h2.5a1 1 0 1 1 0 2H19v2.5a1 1 0 1 1-2 0V15h-2.5a1 1 0 1 1 0-2H17v-2.5a1 1 0 0 1 1-1Z' />
  </Svg>
);
